import React from "react";
import OwnProfileButtons from "./ProfileButtonsOwn";
import OtherProfileButtons from "./ProfileButtonsOther";

const ProfileButtons = ({ isOwn }) => {
    if (!isOwn) {
        return (
            <OtherProfileButtons />
        )
    } else {
        return (
            <OwnProfileButtons />
        );
    }
}

export default ProfileButtons;